import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Switch,
  FormControlLabel,
  CircularProgress,
  Divider,
} from "@mui/material";
import api from "../../services/api";
import { toast } from "react-hot-toast";

const CompanySettings = () => {
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({
    is_sandwich_leave_enabled: false,
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const response = await api.get("/company-settings/");
      setSettings(response.data);
    } catch (error) {
      console.error("Failed to fetch settings:", error);
      toast.error("Failed to load company settings.");
    } finally {
      setLoading(false);
    }
  };

  const handleToggleSandwichLeave = async (e) => {
    const newValue = e.target.checked;
    
    // Optimistic update
    setSettings((prev) => ({
      ...prev,
      is_sandwich_leave_enabled: newValue,
    }));

    try {
      await api.patch("/company-settings/", {
        is_sandwich_leave_enabled: newValue,
      });
      toast.success(
        `Sandwich Leave is now ${newValue ? "Enabled" : "Disabled"}`
      );
    } catch (error) {
      console.error("Failed to update settings:", error);
      toast.error("Failed to update settings.");
      // Revert on error
      setSettings((prev) => ({
        ...prev,
        is_sandwich_leave_enabled: !newValue,
      }));
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Card sx={{ maxWidth: 800, mt: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h6" color="primary" gutterBottom>
            Leave Settings
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={settings.is_sandwich_leave_enabled}
                  onChange={handleToggleSandwichLeave}
                  color="primary"
                />
              }
              label={
                <Typography variant="subtitle1" fontWeight="500">
                  Enable Sandwich Leave
                </Typography>
              }
            />
            <Typography variant="body2" color="text.secondary" sx={{ ml: 6 }}>
              If enabled, weekends and holidays falling strictly between leave
              days are counted as leave.
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CompanySettings;
